import React, { useContext, useEffect, useState } from 'react';
import { Autocomplete, Chip, TextField } from '@mui/material';
import { UserStateContext } from 'context/user-state-context';
import { getTaskCategories } from '../../shared/common.api';

/**
 * CIN-6288: multi-select of the company's managed category names. value/onChange
 * use an array of names (tasks store category names, so the chips and filters all
 * work with names). Options come from the managed TaskCategory list — not free
 * text — so the API's category validation always passes.
 */
export const CategoryMultiSelect = ({
  value = [],
  onChange,
  label = 'Categories',
  disabled
}) => {
  const {
    asCompany
  } = useContext(UserStateContext);
  const [options, setOptions] = useState([]);
  useEffect(() => {
    if (asCompany?.id) {
      getTaskCategories({
        company: asCompany.id,
        limit: 999
      }).then(({
        data
      }) => setOptions((data.results || []).map(c => c.name)));
    }
  }, [asCompany?.id]);
  return <Autocomplete multiple options={options} value={value || []} onChange={(_e, val) => onChange(val)} disabled={disabled} renderInput={params => <TextField {...params} label={label} placeholder="Add categories…" />} renderTags={(vals, getTagProps) => vals.map((opt, index) => {
    const {
      key,
      ...tagProps
    } = getTagProps({
      index
    });
    return <Chip key={opt} size="small" label={opt} {...tagProps} />;
  })} sx={{
    '& .MuiOutlinedInput-root': {
      borderRadius: '14px'
    }
  }} />;
};